"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FETCH_REPORT_FILE_FAILURE = exports.FETCH_REPORT_FILE_SUCCESS = exports.FETCH_REPORT_FILE_REQUEST = exports.CLEAR_REPORT_FILE = void 0;
const namespaced = (name) => `@sok/reports/${name}`;
exports.CLEAR_REPORT_FILE = namespaced('CLEAR_REPORT_FILE');
exports.FETCH_REPORT_FILE_REQUEST = namespaced('FETCH_REPORT_FILE_REQUEST');
exports.FETCH_REPORT_FILE_SUCCESS = namespaced('FETCH_REPORT_FILE_SUCCESS');
exports.FETCH_REPORT_FILE_FAILURE = namespaced('FETCH_REPORT_FILE_FAILURE');
//# sourceMappingURL=file.js.map